<template>
  <div class="context__form-container">
    <Alert v-if="allowedSourceFields.length === 0" type="error">
      <p>{{ $t('sourceFieldSelectSubForm.noField') }}</p>
    </Alert>

    <FormGroup
      v-if="allowedSourceFields.length > 0"
      small-label
      :label="$t('sourceFieldSelectSubForm.selectSourceFieldLabel')"
      required
      :error="fieldHasErrors('source_field_id')"
    >
      <Dropdown
        v-model="v$.values.source_field_id.$model"
        :error="fieldHasErrors('source_field_id')"
        :fixed-items="true"
        @hide="v$.values.source_field_id.$touch"
      >
        <DropdownItem
          v-for="field in allowedSourceFields"
          :key="field.id"
          :name="field.name"
          :value="field.id"
          :icon="field.icon"
        ></DropdownItem>
      </Dropdown>

      <template #error>{{
        v$.values.source_field_id.$errors[0]?.$message
      }}</template>
    </FormGroup>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required, helpers } from '@vuelidate/validators'

import form from '@baserow/modules/core/mixins/form'

export default {
  name: 'SourceFieldSelectSubForm',
  mixins: [form],
  props: {
    fields: {
      type: Array,
      required: true,
    },
    // The field `type` strings this field is allowed to read its value
    // from, e.g. `['text', 'long_text', 'number']`. Unlike
    // `FieldSelectThroughFieldSubForm`, the candidates come straight from
    // `this.fields` (already loaded for the current table) rather than a
    // network round-trip, because the source field always lives in the
    // same table.
    allowedFieldTypes: {
      type: Array,
      required: true,
    },
  },
  setup() {
    return { v$: useVuelidate({ $lazy: true }) }
  },
  data() {
    return {
      allowedValues: ['source_field_id'],
      values: {
        source_field_id: null,
      },
    }
  },
  computed: {
    allowedSourceFields() {
      return this.fields
        .filter((f) => this.allowedFieldTypes.includes(f.type))
        .map((f) => {
          const fieldType = this.$registry.get('field', f.type)
          return { ...f, icon: fieldType.getIconClass() }
        })
    },
  },
  validations() {
    return {
      values: {
        source_field_id: {
          required: helpers.withMessage(
            this.$t('error.requiredField'),
            required
          ),
        },
      },
    }
  },
  methods: {
    isFormValid() {
      return (
        form.methods.isFormValid.call(this) &&
        this.allowedSourceFields.length > 0
      )
    },
  },
}
</script>
